export default "__VITE_ASSET__dyD_sU8u__"